import { render, staticRenderFns } from "./OffersReport.vue?vue&type=template&id=cc460e00&"
import script from "./OffersReport.vue?vue&type=script&lang=js&"
export * from "./OffersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports